import { Container, Flex, HTMLChakraProps } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { BackToLectureButton } from '@/components/ui/features/lecture/EmbedLectureHeader/components/BackToLectureButton';
import { EmbedSettings } from '@/components/ui/features/lecture/EmbedLectureHeader/components/EmbedSettings';
import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { LectureRestriction } from '@/components/ui/features/lecture/LectureHeaderSection/components/LectureRestriction';
import { LectureInfo } from '@/components/ui/features/lecture/LectureInfo/LectureInfo';
import { LectureMediaLock } from '@/components/ui/features/lecture/LecturePlayer/components/LectureMediaLock';
import { LecturePlayer } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer';
import { LecturePlayerVideo } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayerVideo';
import { queryLectureAccessPermission } from '@/queries/lecture-access-permissions';

type ILectureHeaderSectionProps = HTMLChakraProps<'div'>;

export const EmbedLectureHeader: FC<ILectureHeaderSectionProps> = (props) => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data } = useResource(queryLectureAccessPermission(lectureId));

  const isLectureRestricted = data?.restricted;

  return (
    <Section variant="dark" mt={{ base: '-104px', md: '-70px' }} pt={{ base: '104px' }} pb={10} w="full" {...props}>
      <Container color="white" position="relative">
        <LecturePlayer>
          <BackToLectureButton />
          <Flex gap={4} flexDirection={{ base: 'column', lg: 'row' }}>
            <Flex flexDir="column" flex={1}>
              {isLectureRestricted && <LectureMediaLock />}
              {!isLectureRestricted && <LecturePlayerVideo />}
              <LectureInfo />
            </Flex>
            <EmbedSettings />
          </Flex>
        </LecturePlayer>
      </Container>
    </Section>
  );
};
